import { render, staticRenderFns } from "./UpdateBank.vue?vue&type=template&id=5e415314&scoped=true"
import script from "./UpdateBank.vue?vue&type=script&lang=js"
export * from "./UpdateBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e415314",
  null
  
)

export default component.exports